module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.woff?8d9bb2662df63b4e12b8514c508371f1";